export default __webpack_public_path__ + "static/media/11.c33cdb89.png";